import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  question: '¿Funciona si mi pareja no está muy dispuesta?',
  answer: 'El método incluye guiones específicos para iniciar la primera conversación incluso cuando uno de los dos tiene resistencia inicial. El primer paso siempre es el más difícil — y está cubierto.'
}, {
  question: '¿Necesitamos mucho tiempo libre para esto?',
  answer: 'No. Está diseñado específicamente para padres sin tiempo. 10 minutos al día, con estructura clara. No más.'
}, {
  question: '¿Es lo mismo que terapia de pareja?',
  answer: 'No. Es complementario. La terapia trabaja el pasado en profundidad. Acuerdos Express trabaja el presente con acciones concretas. Puedes usar ambos — o solo este si la terapia no está en tu contexto ahora mismo.'
}, {
  question: '¿Para qué etapa del bebé sirve?',
  answer: 'Está diseñado para bebés de 0 a 24 meses, el período donde los conflictos de crianza son más frecuentes e intensos.'
}, {
  question: '¿Y si no funciona para nosotros?',
  answer: '7 días de garantía total. Si no ves valor, te devuelvo cada centavo sin preguntas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 px-4 bg-cream" data-id="element-42">
      <div className="max-w-3xl mx-auto" data-id="element-43">
        <div className="text-center mb-12" data-id="element-44">
          <h2 className="text-3xl md:text-4xl font-bold text-brown mb-4" data-id="element-45">
            Preguntas Frecuentes
          </h2>
          <p className="text-brown-light" data-id="element-46">
            Todo lo que necesitas saber antes de empezar.
          </p>
        </div>

        <div className="space-y-4" data-id="element-47">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-xl border border-blush/20 overflow-hidden shadow-sm" data-id="element-48">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors" data-id="element-49">
                <span className="font-bold text-brown text-lg pr-8" data-id="element-50">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-terracotta flex-shrink-0" data-id="element-51" /> : <ChevronDown className="w-5 h-5 text-terracotta flex-shrink-0" data-id="element-52" />}
              </button>

              <AnimatePresence data-id="element-53">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-54">
                    <div className="px-6 pb-6 text-brown-light leading-relaxed border-t border-gray-100 pt-4" data-id="element-55">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}